import {GetVersionStatus} from './GetVersionStatus';
import {ApiAppRepository} from '@infra/domain/model/App/ApiAppRepository';

export const AppApplication = {
  getVersionStatus: GetVersionStatus(ApiAppRepository),
};
